import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import Autocomplete from "@mui/material/Autocomplete";
import { SEXE_OPTIONS } from "../../shared/constants";
const DemandeurInfoForm = ({
  formData = [],
  errors,
  professions,
  handleChange,
  handleFieldFocus,
  handleChangePhone,
  handleChangePhoneWhatsapp,
}) => {
  return (
    <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8">
      <TextField
        label="Nom du Demandeur"
        fullWidth
        size="small"
        value={formData.nom}
        onChange={(e) => handleChange("nom", e.target.value.toUpperCase())}
        onFocus={() => handleFieldFocus("nom")}
        error={!!errors.nom}
        helperText={errors.nom}
        required
      />
      <TextField
        label="Prenom du demandeur"
        fullWidth
        size="small"
        value={formData.prenom}
        onChange={(e) => handleChange("prenom", e.target.value.toUpperCase())}
        onFocus={() => handleFieldFocus("prenom")}
        error={!!errors.prenom}
        helperText={errors.prenom}
        required
      />
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Sexe</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={formData.sexe}
          label="Sexe"
          onChange={(e) => handleChange("sexe", e.target.value)}
        >
          {SEXE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Email"
        fullWidth
        size="small"
        value={formData.email}
        onChange={(e) => handleChange("email", e.target.value)}
        onFocus={() => handleFieldFocus("email")}
        error={!!errors.email}
        helperText={errors.email}
        type="email"
      />
      <MuiTelInput
        label="Telephone"
        fullWidth
        size="small"
        value={formData.tel2}
        onChange={handleChangePhone}
        onFocus={() => handleFieldFocus("telephone")}
        error={!!errors.telephone}
        helperText={errors.telephone}
        required
      />
      <MuiTelInput
        label="WhatsApp"
        fullWidth
        size="small"
        value={formData.tel1_whatsapp}
        onChange={handleChangePhoneWhatsapp}
        onFocus={() => handleFieldFocus("whatsApp")}
        error={!!errors.whatsApp}
        helperText={errors.whatsApp}
      />
      <Autocomplete
        id="profession"
        options={professions}
        size="small"
        fullWidth
        onChange={(event, value) =>
          handleChange("profession_id", value?.id || "")
        }
        onFocus={() => handleFieldFocus("profession")}
        value={professions.find((p) => p.id === formData.profession_id) || null}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Profession ou secteur d'activité"
            error={!!errors.profession}
            helperText={errors.profession}
          />
        )}
      />

      {/**
       * Si c'est  le client est une entreprise
       * on affiche rccm et ifu
       *
       */}
      {/*  Nous sommes en ajout */}
      {formData.typeClient === "entreprise" && (
        <>
          <TextField
            label="Nom Entreprise"
            fullWidth
            size="small"
            value={formData.nom_entreprise}
            onChange={(e) =>
              handleChange("nom_entreprise", e.target.value.toUpperCase())
            }
            onFocus={() => handleFieldFocus("nom_entreprise")}
            error={!!errors.nom_entreprise}
            helperText={errors.nom_entreprise}
            required
          />
          <TextField
            label="Numero IFU"
            fullWidth
            size="small"
            value={formData.numero_ifu}
            onChange={(e) =>
              handleChange("numero_ifu", e.target.value.toUpperCase())
            }
            onFocus={() => handleFieldFocus("ifu")}
            error={!!errors.ifu}
            helperText={errors.ifu}
            required
          />

          <TextField
            label="RCCM"
            fullWidth
            size="small"
            value={formData.numero_rccm}
            onChange={(e) =>
              handleChange("numero_rccm", e.target.value.toUpperCase())
            }
            onFocus={() => handleFieldFocus("rccm")}
            error={!!errors.rccm}
            helperText={errors.rccm}
            required
          />
        </>
      )}

      {/*  Nous sommes en modification */}
      {formData.cat_cli_code === "02" && (
        <>
          <TextField
            label="Nom Entreprise"
            fullWidth
            size="small"
            value={formData.nom_entreprise}
            onChange={(e) =>
              handleChange("nom_entreprise", e.target.value.toUpperCase())
            }
            onFocus={() => handleFieldFocus("nom_entreprise")}
            error={!!errors.nom_entreprise}
            helperText={errors.nom_entreprise}
            required
          />
          <TextField
            label="Numero IFU"
            fullWidth
            size="small"
            value={formData.numero_ifu}
            onChange={(e) =>
              handleChange("numero_ifu", e.target.value.toUpperCase())
            }
            onFocus={() => handleFieldFocus("ifu")}
            error={!!errors.ifu}
            helperText={errors.ifu}
            required
          />

          <TextField
            label="RCCM"
            fullWidth
            size="small"
            value={formData.numero_rccm}
            onChange={(e) =>
              handleChange("numero_rccm", e.target.value.toUpperCase())
            }
            onFocus={() => handleFieldFocus("rccm")}
            error={!!errors.rccm}
            helperText={errors.rccm}
            required
          />
        </>
      )}
    </div>
  );
};

export default DemandeurInfoForm;
